<script setup lang="ts">
const props = defineProps<{
	title: string | number
	subtitle?: string | number
	size: "md" | "lg" | "xl" | "2xl" | "3xl"
}>()

const sizeClass = computed(() => {
	switch (props.size) {
		case "md":
			return "text-base"
		case "lg":
			return "text-lg"
		case "xl":
			return "text-xl"
		case "2xl":
			return "text-2xl"
		case "3xl":
			return "text-3xl"
		default:
			return "text-base"
	}
})
</script>

<template>
	<div class="flex flex-col gap-0.5 min-w-0">
		<p :class="sizeClass" class="font-semibold text-default leading-tight tracking-tight truncate" :title="String(props.title)">
			{{ props.title }}
		</p>
		<p v-if="props.subtitle" class="text-sm text-muted truncate">{{ props.subtitle }}</p>
	</div>
</template>
